import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Chip } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { ORDERS } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import { useTheme } from '@mui/material/styles';
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import moment from "moment";
import useStore from 'src/contexts/AuthProvider';
import BinIcon from "src/svgComponents/BinIcon";
import AppTooltip from "src/components/common/AppTooltip";
const _ = require('lodash');

const DisputedOrders = () => {
   const [tableData, setTableData] = useState([]);
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const axiosPrivate = useAxiosPrivate();
   const [showImage, setShowImage] = useState();
   const [filterName, setFilterName] = useState('');
   const { enqueueSnackbar } = useSnackbar();
   const [deleteId, setdeleteId] = useState("");
   const [open, setOpen] = useState(false);
   const theme = useTheme();
   const [loding, setLoding] = useState(true);
   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
   const permissionsData = useStore(state => state.permissions);

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'name', label: 'Customer Name', alignRight: false },
      { id: 'email', label: 'Customer Email', alignRight: false },
      { id: 'mobile', label: 'Customer Mobile', alignRight: false },
      { id: 'order_id', label: 'Order Id', alignRight: false },
      { id: 'order_on', label: 'Ordered On', alignRight: false },
      { id: 'order_amount', label: 'Order Amount', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];

   async function getDisputedOrder(page, filterName) {
      const response = await axiosPrivate.get(ORDERS.getVendorDisputedOrder, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
      return response.data[0];
   }

   const { data: disputedOrderList, refetch } = useQuery(['disputedOrderList', page, filterName], () => getDisputedOrder(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (disputedOrderList) {
         setTableData(disputedOrderList.data);
         setRowsPerPage(disputedOrderList?.metadata.length != 0 ? disputedOrderList?.metadata[0].limit : 10);
      }
      if (disputedOrderList?.metadata.length != 0 && disputedOrderList?.metadata[0].hasMoreData == true) {
         getDisputedOrder(page + 1);
      }
      setLoding(false);
   }, [disputedOrderList])

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };
   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);
      getDisputedOrder(page, filterName)
      refetch();
   };

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }
   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });

      return stabilizedThis.map((el) => el[0]);
   }

   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };

   const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

   const handleClose = () => {
      setOpen(false);
      setShowImage('');
   };

   const deleteOrder = async () => {
      const response = await axiosPrivate.delete(ORDERS.deleteDisputedOrder + deleteId)
      if (response.status == 200) {
         enqueueSnackbar("Disputed Order delete successfully", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      } else {
         enqueueSnackbar("something went wrong", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch();
      handleClose();
   };

   const handleClickOpen = (id) => {
      setdeleteId(id);
      setOpen(true);
   };

   return (
      <>
         {loding ? <LoadingScreen /> : <>
            <div className="dashboard_header mb-4">
               <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Disputed Order</h4>
               <Paper component="form" className='dashboard_searchbox col-lg-4'>
                  <IconButton>
                     <SearchIcon />
                  </IconButton>
                  <InputBase
                     fullWidth
                     sx={{ flex: 1 }}
                     placeholder="search ..."
                     onChange={(e) => handleFilterByName(e)}
                     onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                  />
               </Paper>
            </div>
            <Dialog
               fullScreen={fullScreen}
               open={open}
               onClose={handleClose}
               aria-labelledby="responsive-dialog-title"
            >
               <DialogTitle id="responsive-dialog-title" className='m-auto'>
                  {"Are you sure you want to delete?"}
               </DialogTitle>
               <DialogContent>
                  <Stack direction={"row"} spacing={2} justifyContent={'center'}>
                     <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                        cancel
                     </Button>
                     <Button className="theme_button" variant="contained" onClick={() => deleteOrder()} autoFocus>
                        delete
                     </Button>
                  </Stack>
               </DialogContent>
            </Dialog>
            <Card>
               <TableContainer>
                  <Table>
                     <UserListHead
                        headLabel={TABLE_HEAD}
                        rowCount={disputedOrderList?.data?.length}
                        onRequestSort={handleRequestSort}
                     />
                     {filteredUsers?.length > 0 ?
                        <TableBody>
                           {filteredUsers.map((row) => {
                              return (
                                 <StyledTableRow key={row._id}>
                                    <TableCell component="th" scope="row"> {row?.user_data?.firstname ?? '-'} </TableCell>
                                    <TableCell component="th" scope="row"> {row?.user_data?.email ?? '-'} </TableCell>
                                    <TableCell component="th" scope="row"> {row?.user_data?.mobile ?? '-'} </TableCell>
                                    <TableCell component="th" scope="row"> {row?.order_data?.order_id ?? '-'} </TableCell>
                                    <TableCell align="left"> {moment(row.createdAt).format("DD MMM YYYY h:mm A")}</TableCell>
                                    <TableCell component="th" scope="row"> {row?.order_data?.total_amount ? '$' + row?.order_data?.total_amount?.toFixed(2) : '-'} </TableCell>
                                    <TableCell>
                                       <Stack direction="row" spacing={3}>
                                          {
                                             row.status === 0 ? <Chip variant="contained" className="app_status_chip pending" label="Pending" /> : (row.status === 1 ? <Chip variant="contained" className="app_status_chip accepted" label="Complete" /> : (row.status === 2 ? <Chip variant="contained" className="app_status_chip invalid" label="Reject" /> : ''))
                                          }
                                       </Stack>
                                    </TableCell>
                                    <TableCell>
                                       <Stack direction="row" spacing={3}>
                                          {permissionsData?.disputed_order?.substring(2, 3) == "1" ?
                                             <AppTooltip title="Delete" placement="bottom">
                                                <Button variant="text" className="user_list_row_btn" onClick={() => handleClickOpen(row._id)} ><BinIcon /></Button>
                                             </AppTooltip> : ""}
                                       </Stack>
                                    </TableCell>
                                 </StyledTableRow>
                              )
                           })}
                        </TableBody>
                        :
                        <TableBody>
                           <TableRow>
                              <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                 <span className="app_text_16_semibold">No Data Found</span>
                              </TableCell>
                           </TableRow>
                        </TableBody>}
                  </Table>
               </TableContainer>
               <TablePagination
                  component="div"
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  count={disputedOrderList?.metadata.length != 0 ? disputedOrderList?.metadata[0].total : 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
               />
            </Card>
         </>
         }
      </>
   )
}

export default DisputedOrders